import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SupportLandingPageComponent } from './support-landing-page/support-landing-page.component';
import { SupportComponent } from './support.component';
const routes: Routes = [
  {
    path: 'support', component: SupportComponent, children: [
      { path: '', component: SupportLandingPageComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupportRoutingModule { }
